import './index.scss';
import $ from 'jquery';
import './foundation';
import '../node_modules/slick-carousel/slick/slick.min';




function googleMaps() {
    $('.map-inner').addClass('scrolloff');
    $(document).on('click', '.maps', function () {
        $(this).find('.map-inner').removeClass('scrolloff');
    });
    $(".maps").mouseleave(function () {
        $('.map-inner').addClass('scrolloff');
    });
}


function featuredCarousel() {
    if ( $('body').hasClass('home') ) {
        $('.video-header-headline-inner').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            adaptiveHeight: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed:4000,
            fade: true,
            cssEase: 'ease',
            draggable: false,
            swipe: false,
            responsive: [ {
                breakpoint: 1000,
                settings: {
                    swipe: true,
                    autoplay: true,
                    autoplaySpeed:4000,
                }
            },
                {
                    breakpoint: 640,
                    settings: {

                        swipe: true,
                        autoplay: true,
                        autoplaySpeed:4000,
                    }
                }
            ]
        });
        $('.video-header-headline').removeClass('hidden');
    }
}

function mediaCarousel() {
    if ( jQuery('.drc-slider-inner').length > 0 ) {

        $('.drc-slider-inner').each(function () {
            $(this).slick({
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 3,
                adaptiveHeight: false,
                arrows: true,
                autoplay: false,
                cssEase: 'ease',
                draggable: false,
                swipe: false,
                responsive: [{
                    breakpoint: 1000,
                    settings: {
                        swipe: true,
                        slidesToShow: 2,
                    }
                },
                    {
                        breakpoint: 640,
                        settings: {

                            swipe: true,
                            autoplay: true,
                            autoplaySpeed: 4000,
                            slidesToShow: 1,
                        }
                    }
                ]
            });

            $(this).removeClass('hidden');
        });
        $('.video-reveal[data-reveal]').each(function () {
            var modal = $(this);
            modal.on('open.zf.reveal', function() {
                var iframe = $(this).find('.js-videoIframe');
                if ( iframe.attr('src') == "") {
                    var src = iframe.data('src');
                    iframe.attr('src', src);
                }
            });
        });

    }
}


function videoPlay(wrapper) {
    var iframe = wrapper.find('.js-videoIframe');
    var src = iframe.data('src');
    wrapper.addClass('videoWrapperActive');
    iframe.attr('src',src);
}



$(document).ready(function(){
    googleMaps();
    featuredCarousel();

});

$(document).on('click','.js-videoPoster',function(e) {
    e.preventDefault();
    var poster = $(this);
    var wrapper = poster.closest('.js-videoWrapper');
    videoPlay(wrapper);
});

$(window).on('load',function(){
    $(document).foundation();
    mediaCarousel();
});





// WEBPACK FOOTER //
// ./src/index.js